//This value is taken from _abstract.scss 
//Unexpected behavior may arise if these two files are not manually in sync
//todo - look for a way to automatically synchronize AbstractConstants.ts and _abstract.scss
export const largeBreakpoint = 1200; //1200px - _abstract.scss 
export const mediumBreakpoint = 769; //769px - abstract.scss